import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { ChatComponent } from 'src/app/components/modals/chat/chat.component';
import { GlobalVariablesService } from '../../../../../services/global-variables.service';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { StorageService } from '../../../../../services/commons/storage.service';
import { GlobalMethodsService } from '../../../../../services/global-methods.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { ModalService } from '../../../../../services/commons/modal.service';
import { AuthService } from '../../../../../services/commons/auth.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {

  public user: string;
  constructor(private modalCtrl: ModalController,
              public gvs: GlobalVariablesService,
              private callNumber: CallNumber,
              private storage: StorageService,
              public platform: Platform,
              public modalService: ModalService,
              public gms: GlobalMethodsService,
              public authService: AuthService) { 
              }

  async ngOnInit() {
    await this.gms.clearIntervalStatusInstallationEvent();
    this.user = this.gvs.user.userName;
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Soporte', contentGroup: 'Soporte'}); 
  }


  dismiss(value) {
    this.modalService.hide('supportModal', value);
  }

  async callPhone(){
    if(await this.platform.is('cordova')){
      this.callNumber.callNumber(this.gvs.currentInstallation.cust_support_phone, true)
      .then(res => {
        console.log('Launched dialer!', res);
        this.gms.analyticsTrackEvent('event_c2c', {eventCategory: 'SICOR/Soporte', eventAction: 'Accion/Atencion24h'});
      })
      .catch(async err => {
        const message = JSON.stringify(err);
        this.gms.analyticsTrackEvent('event_c2c', {eventCategory: 'SICOR/Soporte', eventAction: 'Error/Atencion24h'});
        await FirebaseCrashlytics.recordException({message: message});
      });
    }else{
      const link = document.createElement('a');
      link.href = 'tel:'+this.gvs.currentInstallation.cust_support_phone;
      link.click();
    }
    
  }

  async initChat() {
    await this.gms.initChat(this.gvs.user.userName, 4);
  }

}
